export const getPrescriptionSatelliteImageUrl = (map, assets) =>
  map.imageUrl || assets[map.sourceLayer];
